
import { css } from 'lit';
export default css`
.accordion{
  display:flex;
  flex-direction:column;
  row-gap:var(--spacing-6);
}
  @media (min-width: 992px){.accordion{
    display:grid
}
  }
  .accordion.has-intro.equal{
    grid-template-columns:1fr 1fr;
  }
  @media (min-width: 992px){
  .accordion.has-intro.equal .accordion--intro{
        padding-right:20%
    }
      }
  .accordion.has-intro.main-right{
    grid-template-columns:35% 65%;
  }
  @media (min-width: 992px){
  .accordion.has-intro.main-right{
      gap:var(--spacing-8)
  }
    }
  .accordion.has-intro.main-right .image{
      display:flex;
      justify-content:center;
    }

.intro-heading{
  color:var(--primary-eggplant);
  margin-bottom:0.5rem;
}

@media (min-width: 992px){

.intro-heading{
    margin-bottom:1rem
}
  }

.intro-description{
  --wysiwyg-font-color:var(--neutral-medium-gray);
}

.intro-image{
  margin-bottom:2rem;
}

@media (min-width: 992px){

.intro-image{
    justify-content:start;
    margin-bottom:0;
    margin-top:4rem
}
  }
`;